<template>
  <div id="app" v-if="$root.loaded">
    <div class="app-border">
      <div class="nc-box">
        <div class="nc-box__container">
          <!-- Content -->
          <section class="mc-content">
            <main class="screen">
              <Intro v-if="!$root.stepping" />
              <Step
                v-if="$root.stepping"
                v-bind="currentStepData"
                :stepNumber="currentStep"
              >
                <template slot="content">
                  <transition name="fade">
                    <Step1
                      key="step-1"
                      v-if="currentStep === 0"
                      v-bind="$root.steps[0]"
                    />

                    <Step2
                      key="step-2"
                      v-if="currentStep === 1"
                      v-bind="$root.steps[1]"
                    />

                    <Step3
                      key="step-3"
                      v-if="currentStep === 2"
                      v-bind="$root.steps[2]"
                    />

                    <Step4
                      key="step-4"
                      v-if="currentStep === 3"
                      v-bind="$root.steps[3]"
                    />
                  </transition>
                </template>
              </Step>
            </main>
          </section>
        </div>
      </div>
    </div>

    <Modal />
  </div>
</template>

<script>
import Intro from '@/components/Intro.vue';
import Step from '@/components/Step.vue';
import Step1 from '@/components/Step1.vue';
import Step2 from '@/components/Step2.vue';
import Step3 from '@/components/Step3.vue';
import Step4 from '@/components/Step4.vue';
import Modal from '@/components/Modal.vue';

export default {
  components: {
    Intro,
    Step,
    Step1,
    Step2,
    Step3,
    Step4,
    Modal,
  },
  data: () => ({}),
  computed: {
    currentStep() {
      return this.$root.currentStep;
    },
    currentStepData() {
      return this.$root.steps[this.currentStep];
    },
  },
  methods: {
    scrollToTop() {
      window.scrollTo(0, 0);
    },

    goToStep(i) {
      if (!this.canGoToStep(i - 1)) {
        return false;
      }

      if (i === 6) {
        i = 5;
      }

      if (this.currentStep === this.steps.length) {
        i = 0;
      }

      return (this.currentStep = i);
    },
  },
};
</script>

<style lang="scss">
$sm: 640px;
$md: 768px;
$lg: 1024px;
$xl: 1280px;

* {
  &,
  &:before,
  &:after {
    box-sizing: border-box;
  }
}

html,
body,
#app,
.app-border,
.nc-box {
  height: 100%;
  margin: 0;
}

body {
  width: 100vw;
  overflow-x: hidden;
}

.app-border {
  display: flex;
  padding: 20px;
  @screen md {
    padding: 25px;
  }
}

h1,
.u-h1 {
  font-size: 35px;
  line-height: 1.2;
  font-weight: 600;
}

.u-h2 {
  font-size: 24px;
  font-weight: 600;
}

.text-24px {
  font-size: 24px;
}

.text-25px {
  font-size: 25px;
}

.nc-box {
  @apply flex flex-col w-full h-auto m-auto;
  min-height: 100vh;

  @screen md {
    min-height: auto;
  }

  .nc-box__container {
    display: flex;
    flex: 1 1 auto;
  }
}

.mc-content {
  flex: 1 1 auto;

  display: flex;
  flex-direction: column;

  padding-bottom: 75px;
  @screen sm {
    @apply pb-0;
  }
}

header,
footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
/*
footer {
  box-shadow: 0 -10px 31px 0 rgba(58, 80, 103, 0.03);

  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  background: rgba(255, 255, 255, 0.97);
  transform: translateY(100%);
  transition: transform 0.13s;
  height: 70px;
  padding: 0 20px;

  &.is-visible.can-go-next {
    transform: none;
  }

  @media screen and (min-width:#{$sm}) {
    height: 78px;
    padding: 0 35px;
    position: static;
    @media screen and (max-height: 833px) {
      position: fixed;
      z-index: 2;
    }
  }
} */

.c-btn,
.tag {
  display: inline-flex;
  border: none;
  transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out;
  outline: none !important;
  @apply select-none;

  vertical-align: middle;

  font-weight: 600;
  font-size: 25px;
  letter-spacing: 0px;
  line-height: 1;
  text-align: center;

  /* [4] */
  margin: 0;

  /* [4] */
  cursor: pointer;

  /* [5] */

  border-radius: 2rem;
  text-decoration: none;
  padding: 10px 30px 11px 30px;
  @screen md {
    padding: 15px 60px 17px 60px;
  }
  /* [4] */
  align-items: center;
  justify-content: center;

  img,
  svg {
    margin-right: 10px;
    height: 1em;
    width: auto;
  }

  i {
    margin-right: 10px;
  }

  &[disabled] {
    opacity: 0.8;
  }

  &--accent {
    background-color: #6062ff;
    border: 2px solid #6062ff;
    color: #fff;
    &:hover {
      background-color: darken(#6062ff, 5%);
      border-color: darken(#6062ff, 5%);
    }
    &:active {
      background-color: darken(#6062ff, 10%);
      border-color: darken(#6062ff, 10%);
    }
  }
  &--outline {
    background-color: transparent;
    border: 2px solid #6062ff;
    color: #6062ff;
    &:hover {
      background-color: transparentize($color: #6062ff, $amount: 0.85);
      /* color: #fff; */
    }
    &:active {
      background-color: darken(#6062ff, 10%);
      border-color: darken(#6062ff, 10%);
    }
  }
}

.tag {
  border-radius: 2rem;
  text-transform: uppercase;
  background: transparentize($color: #00a982, $amount: 0.86);
  border: 1px solid #0dbb93;
  font-size: 10px;
  color: #0dbb93;
  cursor: default;
  pointer-events: none;
  padding: 5px 13px 4px 13px;
  font-weight: 700;
}

img {
  max-width: 100%;
}

.allow-select {
  user-select: all;
}
</style>
